export const SITE_NAME = "FirmIndex";
export const SITE_URL = "https://firmindex.cz";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-fallback.png`;

interface MetaTagOptions {
	title: string;
	description: string;
	canonical: string;
	ogImage?: string;
	ogImageAlt?: string;
	noindex?: boolean;
}

export function generateMetaTags({
	title,
	description,
	canonical,
	ogImage = DEFAULT_OG_IMAGE,
	ogImageAlt = `${SITE_NAME} – finanční data českých firem`,
	noindex = false,
}: MetaTagOptions) {
	const tags: Array<Record<string, string>> = [
		{ title },
		{ name: "description", content: description },
		// Open Graph
		{ property: "og:title", content: title },
		{ property: "og:description", content: description },
		{ property: "og:url", content: canonical },
		{ property: "og:type", content: "website" },
		{ property: "og:site_name", content: SITE_NAME },
		{ property: "og:locale", content: "cs_CZ" },
		{ property: "og:image", content: ogImage },
		{ property: "og:image:type", content: "image/png" },
		{ property: "og:image:width", content: "1200" },
		{ property: "og:image:height", content: "630" },
		{ property: "og:image:alt", content: ogImageAlt },
		// Twitter Card
		{ name: "twitter:card", content: "summary_large_image" },
		{ name: "twitter:title", content: title },
		{ name: "twitter:description", content: description },
		{ name: "twitter:image", content: ogImage },
		{ name: "twitter:image:alt", content: ogImageAlt },
		// Canonical
		{ tagName: "link", rel: "canonical", href: canonical },
	];

	if (noindex) {
		tags.push({ name: "robots", content: "noindex, nofollow" });
	}

	return tags;
}
